import { combineReducers } from "redux";

import tabs from "./tabs";
import companies from "./companies";
import siteZones from "./siteZones";
import tabHistory from "./tabHistory";
import liveEvents from "./liveEvents";
import correctConfirmValue from "./correctConfirmValue";

import { driveInOut, trainInOut, walkInOut } from "../../constants/reducers";
import {
  SELECT_SITE,
  RESET_SITE,
  SELECT_TAB,
  SELECT_SECTION,
  SET_INITIALIZED,
} from "../../constants/actionTypes";

const activeSite = (state = {}, action) => {
  switch (action.type) {
    case SELECT_SITE:
      return action.payload;
    case RESET_SITE:
      return {};
    default:
      return state;
  }
};

const activeTab = (state = 0, action) => {
  switch (action.type) {
    case SELECT_TAB:
      return action.tab;
    default:
      return state;
  }
};

const activeLogDetailsTab = (state = "main", action) => {
  switch (action.type) {
    case SELECT_SECTION:
      return action.section;
    default:
      return state;
  }
};

const initialized = (state = false, action) => {
  switch (action.type) {
    case SET_INITIALIZED:
      return action.payload;
    default:
      return state;
  }
};

const siteEntranceExitReducer = combineReducers({
  siteZones,
  tabs,
  companies,
  activeSite,
  activeTab,
  activeLogDetailsTab,
  tabHistory,
  correctConfirmValue,
  liveEvents,
  initialized,
});

const siteEntranceExitWrapperReducer = (reducerFunction, reducerName) => {
  return (state, action) => {
    const { name } = action;
    const isInitializationCall = state === undefined;
    if (name !== reducerName && !isInitializationCall) return state;

    return reducerFunction(state, action);
  };
};

export default combineReducers({
  driveInOut: siteEntranceExitWrapperReducer(siteEntranceExitReducer, driveInOut),
  walkInOut: siteEntranceExitWrapperReducer(siteEntranceExitReducer, walkInOut),
  trainInOut: siteEntranceExitWrapperReducer(siteEntranceExitReducer, trainInOut)
});
